import { type UTMParameters } from '@lib/browsers/utm/types'
import urlWithQueryParams from './urlWithQueryParams'

/**
 * Appends camel-case UTM parameters to the given URL
 */
export const appendUtmParameters = (
  url: string,
  utmParameters: UTMParameters,
) => {
  return urlWithQueryParams(url, utmParameters)
}
